function simulateEvent(target, type, detail, options) {
  const event = new CustomEvent(type, {
    detail,
    bubbles: options?.bubbles ?? true,
    composed: options?.composed ?? true
  });
  target.dispatchEvent(event);
}
function waitForEvent(target, type, timeout = 1e3) {
  return new Promise((resolve, reject) => {
    let timer;
    const handler = (event) => {
      clearTimeout(timer);
      target.removeEventListener(type, handler);
      resolve(event);
    };
    target.addEventListener(type, handler);
    timer = setTimeout(() => {
      target.removeEventListener(type, handler);
      reject(new Error(`waitForEvent: "${type}" not received within ${timeout}ms`));
    }, timeout);
  });
}
function captureEvents(target, types) {
  const events = {};
  const listeners = [];
  for (const type of types) {
    events[type] = [];
    const handler = (e) => {
      events[type].push(e);
    };
    listeners.push({ type, handler });
    target.addEventListener(type, handler);
  }
  const cleanup = () => {
    for (const { type, handler } of listeners) {
      target.removeEventListener(type, handler);
    }
  };
  return { events, cleanup };
}
export {
  captureEvents,
  simulateEvent,
  waitForEvent
};
//# sourceMappingURL=events.js.map
